<template>
  <div>
    <!-- ############ Content START-->
    <div id="content" class="flex ">
        <!-- ############ Main START-->
        <div>
            <div class="page-hero page-container " id="page-hero">
                <div class="padding pb-0 d-flex">
                        <h1 class="text-md text-highlight mb-0 pb-0">Let's find your next customer</h1>
                </div>
                
                
                <div class="page-content page-container">
                    <div class="padding pb-0 pt-3 pb-0">
                        <form class="input-group main-search-input" @submit.prevent="handleUrlSearch()">
                            <input v-model="query"
                                   ref="searchbar"
                                   @input="validateDomain(query)"  
                                   type="search"
                                   class="form-control typeahead tt-input"
                                   placeholder="Enter company domains or keywords..."
                                   data-plugin="typeahead">
                            <button type="submit" class="btn no-shadow px-0">Search</button>
                        </form>
                    </div>
                </div>
            </div>

            <div class="page-content page-container" id="page-content">
                <div v-if="company_searched.crawl_status=='crawled'" class="padding mt-5">
                  <h5>Showing results for: </h5>
                  <div class="px-4 py-3 company-profile d-flex ">
                      <div>
                          <h3>{{company_searched.name || company_searched.domain}}</h3>
                          <hr>
                          <div style="color:gray">
                              <a :href="'http://'+company_searched.domain" class="company-prop item-company" target="_blank">
                                {{company_searched.domain}}
                              </a>
                              <span class="company-prop">{{company_searched.industry}}</span>
                              <a class="company-prop" :href="'https://linkedin.com/' + company_searched.linkedin_name" target="_blank">
                                  <linkedin-icon class="custom-class" width="16" height="16"></linkedin-icon>
                              </a>
                              <span class="company-prop">{{ (company_searched.numberofemployees || 10) + '+ Employees' }}</span>
                              <span class="company-prop">{{ company_searched.location }}</span>
                          </div>
                      </div>
                      <div style="margin-left: auto;">
                          <router-link class="btn w-sm mb-1 btn-light" :to="/companyProfile/+company_searched.id+'/'+company_searched.name" tag="a" role="button">View Profile</router-link>
                      </div>
                  </div>        
              </div>
              <RecommendationList v-if="recommendations.length"
                                  :source="company_searched"
                                  :recommendations="recommendations"
                                  :currentPage="currentPage"
                                  routedFrom="search"
                                  @pagechange="onPageChange"
                                  @feedback="handleFeedback">
              </RecommendationList>
              <div v-if="isSearching" style="text-align: center;">
                <div class="spinner-border text-primary" style="width: 5rem; height: 5rem; margin: 8rem;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-if="showErrorMessage || (company_searched && company_searched.crawl_status!='crawled')" class="padding">
                <div class="p-4 alert alert-danger">
                  <h5 class="alert-heading">Search Error</h5>
                  Sorry, cannot crawl <em> {{query_searched}} </em> at the moment. Please check your spelling.
                </div>
              </div>
            </div>
        </div>
        <!-- ############ Main END-->
    </div>
    <!-- ############ Content END-->
  </div>
</template>

<script type="text/javascript">
import RecommendationList from '@/components/RecommendationList';
import { LinkedinIcon } from 'vue-feather-icons';



export default{
  components:{RecommendationList, LinkedinIcon},
  data(){
    return {
      search_type: null,
      isUploading: false,
      isSearching: false,
      showModal: false,
      persona_chosen: '',
      file_chosen: '',
      query_searched: '', // query might be a URL or keyword
      query: '',
      keyword_searched: '',
      company_searched: '',
      file_uploaded: '',
      all_headers: [],
      header_name: '',
      header_domain: '',
      header_country: '',
      header_location: '',
      files: [],
      personas: [],
      recommendations:[],
      currentPage: 1,
      submitError: {
        duration: 0,
        text: ""
      },
      recommendationError: {
        duration: 0,
        text: ""
      },
      searchErrorMessage:'',
      showErrorMessage: false
    };
  },
  watch: {
    company_searched: {
      //immediate: true,
      handler:  function(newCompany, oldCompany) {
        if(!newCompany.id || newCompany.crawl_status=="uncrawled"|| this.recommendations.length)
            return

        const path = process.env.API_LOCATION + `/recommend/${newCompany.id}`;

        var that = this;
        this.isSearching = true;
        this.query = ''; // clear the search bar

        this.$http.get(path)
            .then((res) => {
              that.recommendations = res.data.companies;
              var distances = res.data.distances;
              for (var i = that.recommendations.length - 1; i >= 0; i--) {
                that.recommendations[i]['rank'] = i+1;
                that.recommendations[i]['distance'] = distances[i];
              }
              //console.log("Successfully loaded recommendations.");
              //console.log(res);
            })
            .catch((error) => {
              console.log("Error loading recommendations.");
              console.error(error);
              that.showErrorMessage = true;
            })
            .finally(() => {
              that.isSearching = false;
              that.updateState();
            });
        }
      }
  },
  methods: {
    /**
      Execute operations related to QuickSearch.
      First, check whether the entered text is a proper URL.
      If yes, search the entered URL 
    */
    async handleUrlSearch() {
      if(!this.validateDomain(this.query))
        return;

      this.company_searched = '';
      this.recommendations = [];
      this.persona_chosen = '';
      this.file_chosen = '';
      this.keyword_searched = '';
      this.currentPage = 1;
      var that = this;

      this.query_searched = this.query.toLowerCase();
      this.saveState();

      that.isSearching = true;
      console.log("Searching URL...");
      const searchPath = process.env.API_LOCATION + '/search_domain';
      const pollPath = process.env.API_LOCATION + '/poll_search';
      var pollerId = null;
      var taskId = "";

      try {
        var res = await that.$http.get(searchPath, {params: {domain: that.query_searched}});

        if(res.data.status!="crawling") {
            that.isSearching = false;
            that.company_searched = res.data.company;
            console.log(`Search ended with status ${res.data.status}.`);
        }
        else {
            taskId = res.data.task_id
            console.log(taskId)

            if(taskId!==''){
              var checkSearchStatus = async () => {
                console.log("checkSearchStatus");
                try {
                  var res = await that.$http.get(pollPath, {params: {domain: that.query_searched, taskid: taskId}})
                  console.log(res.data);
                  if(res.data.status!="crawling") {
                    clearInterval(pollerId);
                    this.isSearching = false;
                    that.company_searched = res.data.company;
                    console.log(`Search ended with status ${res.data.status}.`);
                  }
                } 
                catch (error) {
                  clearInterval(pollerId);
                  console.log("Error while searching domain.");
                  console.error(error); 
                  that.isSearching = false;
                  that.showErrorMessage = true;        
                }
              };

              checkSearchStatus();
              var pollerId = setInterval(checkSearchStatus, 200);
            }
        }
      } 
      catch(error) {
        console.log("Error while searching domain.");
        console.error(error);
        that.isSearching = false;
      }

    },

    validateDomain(domain) {
      const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
      let isValidDomain = domain.match(regex);
      
      var searchBar = this.$refs["searchbar"];
      if(!isValidDomain)
        searchBar.setCustomValidity("Please enter a valid domain.");
      else 
        searchBar.setCustomValidity("");
      
      return isValidDomain;
    },

    handleKeywordSearch(){
      this.persona_chosen = '';
      this.file_chosen = '';
      this.company_searched = '';
      var that = this;
      
      that.keyword_searched = that.query_searched;
      console.log(that.query_searched);

      that.isSearching = true;
      console.log("Searching keyword...");
      const path = process.env.API_LOCATION + '/search_keyword';

      that.$http.get(path, 
                     {params: {keyword: that.query_searched}}
      ).then((res) => {
        that.recommendations = res.data.companies;
        console.log(`Search ended with status ${res.status_code}.`);
      }).catch((error) => {
        console.log("Error while searching keyword.");
        console.error(error);
      }).finally(() => {
        that.isSearching = false;
      });        
    },


    uploadFile(){
      this.isUploading = true;
      let formData = new FormData();
      formData.append('fileToUpload', this.file_uploaded);
      const path = process.env.API_LOCATION + '/headers';

      var that = this;
      this.$http.post(path,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((res)=> {
          console.log('SUCCESS!!');
          that.all_headers = res.data.headers;
          //that.isUploading = false;
          that.submitError.text = "";
          this.$refs.modal.show();
          // refresh file list
          that.getFiles();

      }).catch(function(error){
          that.submitError.duration = 5;
          that.submitError.text = error.response.data.message || "An unknown error has occured. We will check it out shortly. Sorry for the inconvenience...";
          console.log(error);
          console.log("Backend error message: ");
          console.log("-----------------------------------------------------------------");
          console.log(error.response.data.exception);
          console.log("-----------------------------------------------------------------");
      })
      .finally(() => {
          that.isUploading = false;
      });
    },


    handleOk(evt){
      evt.preventDefault();
      if (!this.header_domain) {
        alert('Domain field is a required field. Please select one from menu.');
      }
      else {
        this.processUploadedFile();
      }
    },


    handleFeedback(company_id, vote){
      console.log("Feedback!");
      console.log(company_id, vote);

      var formData = new FormData();
      formData.append('rec_company_id', company_id);
      formData.append('vote', vote);
      console.log(this.persona_chosen);
      if(this.persona_chosen) {
        formData.append('cluster_id', this.persona_chosen.id);
        formData.append('file_id', this.file_chosen.id);
      } else {
        formData.append('company_id', this.company_searched.id);
      }
      const path = process.env.API_LOCATION + '/feedback';
      var that = this;

      this.$http.post(path,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function(){
          console.log("Feedback successfully submitted!");
      }).catch(function(error){
          console.log("Error while submitting feedback!");
      });
    },


    processUploadedFile(){
      this.$refs.modal.hide();

      let formData = new FormData();  // initialize the form data
      formData.set('domain', this.header_domain);
      formData.set('name', this.header_name);
      formData.set('country', this.header_country);
      formData.set('location', this.header_location);
      formData.append('fileToUpload', this.file_uploaded);

      const path = process.env.API_LOCATION + '/upload_file';
      var that = this;
      this.isUploading = true;

      this.$http.post(path,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function(){
          that.submitError.duration = 0;
          that.submitError.text = "";

          // refresh file list
          that.getFiles();

      }).catch(function(error){
          that.submitError.duration = 5;
          that.submitError.text = error.response.data.message || "An error has occurred!";
          console.log(error);
          console.log("Backend error message: ");
          console.log("-----------------------------------------------------------------")
          console.log(error.response.data.exception)
          console.log("-----------------------------------------------------------------")
      })
      .finally(() => {

          that.isUploading = false;
          that.file_uploaded = {};
          that.header_name = '';
          that.header_domain = '';
          that.header_country = '';
          that.header_location = '';
        });

    },


    loadData(file) {
      this.company_searched = '';
      this.keyword_searched = '';
      this.file_chosen = file;

      var fileId = file.id;
      const path = process.env.API_LOCATION + `/files/${fileId}`;
      var that = this;


      this.$http.get(path)
        .then((res)=>{
          that.personas = res.data.personas;
          that.currentFile = file;
        })
        .catch((error)=> {
          console.log(error);
        });
    },


    getFiles() {
      const path = process.env.API_LOCATION + '/files';
      var that=this;

      this.$http.get(path)
        .then((res) => {

          that.files = res.data.files;
          console.log(that.files);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onPageChange(page) {
      this.currentPage = page;
      this.saveState();
    },

    recommend(persona) {
      this.persona_chosen = persona
      var ids = persona.companies.map(c => c.id);
      const path = process.env.API_LOCATION + '/recommend/';
      var that = this;

      this.$http.get(path, {params: {'ids': ids}})
        .then((res) => {
          that.recommendations = res.data.companies;
          console.log("Successfully loaded recommendations.");
          console.log(res);
        })
        .catch((error) => {
          that.recommendationError.duration = 5;
          that.recommendationError.text = error.response.data.message || "An error has occurred!";
          console.log(error);
          console.log("Backend error message: ");
          console.log("-----------------------------------------------------------------");
          console.log(error.response.data.exception);
          console.log("-----------------------------------------------------------------");
        });

    },

    reloadState() {
      console.log("Reload page"); 
      Object.assign(this.$data, window.history.state);

      const domain = this.$route.query.domain;

      if(domain && domain!=this.query_searched) {
        this.query = domain;
        this.handleUrlSearch();
        console.log(typeof(this.$route.query.page));
        this.currentPage = parseInt(this.$route.query.page) || 1;
      }
    },

    saveState() {
      let url = this.$route.path + "?domain=" + this.query_searched + "&page=" + this.currentPage;
      window.history.pushState(this.$data, null, url);
    },

    updateState() {
      let url = this.$route.path + "?domain=" + this.query_searched + "&page=" + this.currentPage;
      window.history.replaceState(this.$data, null, url);
    }
  },

  mounted() {
    // read state from history api
    this.reloadState();
    window.onpopstate = () => {this.reloadState()}
  },

};  

</script>



// WEBPACK FOOTER //
// src/components/FrontPage.vue